/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ObjectionPositionReductionV1Dto } from './ObjectionPositionReductionV1Dto';
export type PatchObjectionPositionV1Dto = {
  /**
   * The current version of the contract.
   */
  version: number;
  /**
   * UUID of the OperatingCostInvoiceLineItem
   */
  lineItemId?: string;
  /**
   * Comment specific to this line item within the objection
   */
  comment?: string;
  status?: PatchObjectionPositionV1Dto.status;
  /**
   * The green reduction contribution
   */
  reductionGreen?: ObjectionPositionReductionV1Dto;
  /**
   * The yellow reduction contribution
   */
  reductionYellow?: ObjectionPositionReductionV1Dto;
  /**
   * The red reduction contribution
   */
  reductionRed?: ObjectionPositionReductionV1Dto;
};
export namespace PatchObjectionPositionV1Dto {
  export enum status {
    UNCLEAR = 'Unclear',
    IN_CLARIFICATION = 'InClarification',
    CLARIFIED = 'Clarified',
  }
}
